export default __webpack_public_path__ + "static/media/karan-huynh.59937fb6.png";